export function buildSelectedValued(searchfields) {
  if (!searchfields) {
    return [];
  }
  let ret = [];
  searchfields.forEach((element) => {
    if (element?.type === "select") {
      let field = {};
      field.selectedValues = [];
      field.value = element.value;
      ret.push(field);
    }
  });
  return ret;
}

export function buildSearchValue(searchfields) {
  if (!searchfields) {
    return [];
  }
  let returnValue = [];
  searchfields.forEach((element) => {
    if (element?.type === "text" || element?.type === "date") {
      let field = {};
      field.name = element.value;
      field.value = "";
      returnValue.push(field);
    }
  });
  return returnValue;
}

export function hasSelectFields(searchfields) {
  if (!searchfields) {
    return false;
  }
  for (let i = 0; i < searchfields.length; i++) {
    const element = searchfields[i];
    if (element?.type === "select") {
      return true;
    }
  }
  return false;
}

export const paramsToObject = (params) => {
  if (params === "") return {};
  const urlParams = new URLSearchParams(params);
  console.log(urlParams);
  const paramsObj = Object.fromEntries(urlParams);
  paramsObj.page && delete paramsObj.page;
  const paramsResult = Object.entries(paramsObj || {})
    .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
    .join("&");
  return paramsResult;
};

export const formatLenguajeFacet = (query, noEnd = false) => {
  try {
    if (!query?.idioma) {
      return [
        {
          displayText: "Todos los Idiomas",
          value: " ",
          selected: true,
          disabled: false,
          isDefault: true,
        },
      ];
    }
    var resultadosFormateados = [
      {
        displayText: "Todos los Idiomas",
        value: " ",
        selected: true,
        disabled: false,
        isDefault: true,
      },
    ];
    query.idioma.forEach((element) => {
      const aux = {
        displayText: `${element.nombre} (${element.cantidad})`,
        value: element.nombre,
        selected: false,
        isDefault: false,
      };
      resultadosFormateados.push(aux);
    });
    if (resultadosFormateados.length <= 5) {
      noEnd = true;
    }
    if (!noEnd) {
      resultadosFormateados.push({
        displayText: "Ver Más...",
        value: "more",
        selected: false,
        disabled: false,
      });
    }
    // console.log(resultadosFormateados);
    return resultadosFormateados;
  } catch (error) {
    console.log(error);
    return [
      {
        displayText: "Todos los Idiomas",
        value: " ",
        selected: true,
        disabled: false,
        isDefault: true,
      },
    ];
  }
};
